// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
	background-color: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;

	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
}

.modal-content {
	width: 312px;
	overflow-wrap: break-word;
	min-height: 256px;
	max-height: 700px;
	background-color: white;
	padding: 20px;
	margin: 0px;
	border-radius: 8px;
	position: relative;
}

.success-image {
	width: 100px;
	height: 100px;
	position: absolute;
	top: -0;
	left: 50%;
	transform: translate(-50%, -50%);
	overflow: hidden;
	z-index: 1;
}

/* Success Modal CSS */
#modal-title {
	font-size: 24px;
	margin-top: 71px;
	text-align: center;
}

#modal-btn {
	margin: 32px 0px 0px 0px;
	text-transform: none;
}

#modal-message {
	margin-top: 71px;
	text-align: center;
}

#modal-sub-message {
	margin-top: 24px;
	color: #646464;
	font-weight: 500;
	text-align: center;
}

#modal-recipients {
	overflow: hidden;
}
#modal-recipients-headng {
	color: #8e8e8e;
	margin: 18px 0px 16px 0px;
}

#modal-recipient-name {
	margin: 0px;
}

#modal-recipient-email {
	color: #8e8e8e;
	margin: 0px 0px 16px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Modal/SuccessModal/success-modal.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,aAAa;;CAEb,sBAAsB;CACtB,8BAA8B;CAC9B,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,iBAAiB;CACjB,iBAAiB;CACjB,uBAAuB;CACvB,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,gCAAgC;CAChC,gBAAgB;CAChB,UAAU;AACX;;AAEA,sBAAsB;AACtB;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,wBAAwB;AACzB","sourcesContent":[".modal-container {\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbox-sizing: border-box;\n}\n\n.modal-content {\n\twidth: 312px;\n\toverflow-wrap: break-word;\n\tmin-height: 256px;\n\tmax-height: 700px;\n\tbackground-color: white;\n\tpadding: 20px;\n\tmargin: 0px;\n\tborder-radius: 8px;\n\tposition: relative;\n}\n\n.success-image {\n\twidth: 100px;\n\theight: 100px;\n\tposition: absolute;\n\ttop: -0;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\toverflow: hidden;\n\tz-index: 1;\n}\n\n/* Success Modal CSS */\n#modal-title {\n\tfont-size: 24px;\n\tmargin-top: 71px;\n\ttext-align: center;\n}\n\n#modal-btn {\n\tmargin: 32px 0px 0px 0px;\n\ttext-transform: none;\n}\n\n#modal-message {\n\tmargin-top: 71px;\n\ttext-align: center;\n}\n\n#modal-sub-message {\n\tmargin-top: 24px;\n\tcolor: #646464;\n\tfont-weight: 500;\n\ttext-align: center;\n}\n\n#modal-recipients {\n\toverflow: hidden;\n}\n#modal-recipients-headng {\n\tcolor: #8e8e8e;\n\tmargin: 18px 0px 16px 0px;\n}\n\n#modal-recipient-name {\n\tmargin: 0px;\n}\n\n#modal-recipient-email {\n\tcolor: #8e8e8e;\n\tmargin: 0px 0px 16px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
